import { LocationVarKey } from "@swivl-mono/types";

import { TOPIC_VARS_BY_ID } from "../../../Views/Properties/CortexV3/Topics";
import { CortexTopicWorksheet } from "../Components/CortexTopicWorksheet";

export const PAGE_KEYS: LocationVarKey[] = TOPIC_VARS_BY_ID["welcome-messages"] ?? [];

/** Tiered welcome messages (ENG-3115) — org scope only; the spec has no per-location variants. */
export default function WelcomeMessagesPage(): React.ReactElement {
  return (
    <CortexTopicWorksheet
      topicId="welcome-messages"
      heading="Welcome Messages"
      description="Your own opening line for known customers, returning users and unknown callers — per channel. Replaces the bot's greeting when on."
      sectionEditing
    />
  );
}
